export default __webpack_public_path__ + "static/media/young+woman+yoga+leg+and+arm+stretch+in+Beaconsfield.02ae6143.jpeg";